import { RolModel } from './rol.model';
import { EstadoSolicitudModel } from './estado-solicitud.model';
import { EstadoUsuarioModel } from './estado-usuario.model';

export class UserModel {

    id: number;
    nombre: string;
    apellido: string;
    nif: string;
    usuario: string;
    email: string;
    telefono: string;
    password: string;
    tiempoAvisoFinEstacionamiento: number;
    usuarioActivo: boolean;
    sesionActiva: boolean;
    ldap: boolean;
    roles: RolModel[];
    estadoUsuario: EstadoUsuarioModel;


    constructor() {
        this.nombre = '';
        this.apellido = '';
        this.nif = '';
        this.usuario = '';
        this.email = '';
        this.telefono = '';
        this.password = '';
        this.tiempoAvisoFinEstacionamiento = null;
        this.usuarioActivo = true;
        this.sesionActiva = false;
        this.ldap = false;
        this.roles = [];
    }
}
